import { BILLING_TYPE, PaymentFormValues, PaymentInfo, TYPE_INSTALLMENTS } from "../../../../../../../../types/payment.type";
import { calculateNewPaymentAmount } from '../../../../../../helpers/calculationUtils';
import { useEffect, useMemo } from 'react';
import { numberToCurrency } from '../../../../../../../../common/helpers/currency.helpers';

export interface usePaymentFormProps {
  data: PaymentInfo;
  paymentOverdue?: PaymentInfo;
  renterId: string;
}

export function usePaymentForm({ data, paymentOverdue, renterId, }: usePaymentFormProps) {
  
  const statusPayment = data.status;
  const history = data?.history?.[data.history.length - 1].data ?? null;
  const installmentId = history?.installment ? history.installment : data?.installment;

  // Versão corrigida do código
  const percentualValuePayment = Array.isArray(history?.split) && history.split.length > 0
    ? history.split[history.split.length - 1]?.percentualValue ?? 0
    : 0;

  const initialValues = useMemo((): PaymentFormValues => {
    const value = data.value!;
    let newValue = 0;
    if (statusPayment === 'OVERDUE' && paymentOverdue) {
      const valueWithInterest = calculateNewPaymentAmount(paymentOverdue);
      newValue = valueWithInterest;
    }
    return {
      billingType: data.billingType!,
      customer: data.customerId!,
      description: data.description!,
      dueDate: (data.dueDate || '').split('T')[0],
      installmentId: installmentId,
      installmentType: TYPE_INSTALLMENTS.UNDEFINED,
      installmentValue: "",
      installments: "",
      newValue: newValue,
      nextDueDate: "",
      paymentId: data._id!,
      paymentMethod: data.billingType!,
      percentualValueSplit: percentualValuePayment,
      renterId: renterId,
      statusPayment: statusPayment!,
      totalValue: "",
      value: value,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, paymentOverdue, statusPayment, installmentId]);
  // Calcule `totalValue` com base no método de pagamento, sem modificar o estado diretamente
  const totalValue = useMemo(() => {
    const rawTotalValue = initialValues.totalValue.replace(/\D/g, "");
    const numericTotalValue = parseFloat(rawTotalValue) / 100;
    return initialValues.paymentMethod === "credit" ? numericTotalValue + 50 : numericTotalValue;
  }, [initialValues.paymentMethod, initialValues.totalValue]);


  const installments = useMemo(() => [
    { value: '-', label: '-' },
    { value: '1', label: `1 x R$ ${numberToCurrency((totalValue / 1).toFixed(2))}` },
    { value: '2', label: `2 x R$ ${numberToCurrency((totalValue / 2).toFixed(2))}` },
    { value: '3', label: `3 x R$ ${numberToCurrency((totalValue / 3).toFixed(2))}` },
  ], [totalValue]);

  const paymentOptions = useMemo(() => {
    const options = [
      { value: "-", label: "-" },
      { value: BILLING_TYPE.PIX, label: "PIX" },
      { value: BILLING_TYPE.BOLETO, label: "BOLETO" },
    ];
    if ((/CAUÇÃO/.test(data.description!))) {
      options.push({ value: BILLING_TYPE.CREDIT_CARD, label: "CRÉDITO" });
    }
    return options;
  }, [data.description]);


  useEffect(() => {
    if (statusPayment === 'OVERDUE' && paymentOverdue) {
      const valueWithInterest = calculateNewPaymentAmount(paymentOverdue);
      initialValues.newValue = valueWithInterest;
    }
  }, [paymentOverdue, statusPayment, data, initialValues]);


  return {
    initialValues,
    installments,
    paymentOptions,
    totalValue,

  };
}
